import "./product.css";
export default function Productdetailsloading() {
  return (
    <div className="loading">
      <div className="item-details">
        <div className="images-item skeltion"></div>
        <div className="detailes-item">
          <h5 className="loadingtext skeltion"></h5>
          <h5 className="loadingtext skeltion"></h5>
          <h5 className="loadingtext skeltion"></h5>
          <h5 className="loadingtext skeltion"></h5>
          <h5 className="loadingtext skeltion"></h5>
        </div>
      </div>
    </div>
  );
}
